import { render } from "./infoCard.vue?vue&type=template&id=1010ec41"
import script from "./infoCard.vue?vue&type=script&lang=js"
export * from "./infoCard.vue?vue&type=script&lang=js"

import "./infoCard.vue?vue&type=style&index=0&id=1010ec41&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__